import { useState, useEffect, useCallback } from 'react';
import { settingsService } from '@/lib/storage';

interface VoiceSettings {
  enabled: boolean;
  successSound: string;
  failSound: string;
  clickSound: string;
  volume: number;
}

const defaultSettings: VoiceSettings = {
  enabled: true,
  successSound: 'ale-le-le.mp3',
  failSound: 'sabun.mp3',
  clickSound: 'anime-ahh.mp3',
  volume: 0.6,
};

export function useVoiceSettings() {
  const [settings, setSettings] = useState<VoiceSettings>(defaultSettings);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    settingsService.getVoiceSettings().then((s) => {
      setSettings(s);
      setLoaded(true);
    }).catch(() => setLoaded(true));
  }, []);

  const playSound = useCallback((type: 'success' | 'fail' | 'click') => {
    if (!settings.enabled) return;
    const filename = type === 'success' ? settings.successSound
      : type === 'fail' ? settings.failSound
      : settings.clickSound;
    const audio = new Audio(`/voices/${filename}`);
    audio.volume = settings.volume;
    audio.play().catch(() => {});
  }, [settings]);

  const toggleEnabled = useCallback(async () => {
    const newEnabled = !settings.enabled;
    setSettings({ ...settings, enabled: newEnabled });
    await settingsService.updateVoiceSettings({ enabled: newEnabled });
  }, [settings]);

  return { settings, loaded, playSound, toggleEnabled };
}
